import React from 'react'
import { DialogContent } from './constants'
import { ModalWeb } from '../../components/ModalWeb'

interface AppointmentsConfirmationProps {
  isDialogOpen: boolean
  dialogContent: DialogContent
}

export const AppointmentsConfirmation: React.FC<AppointmentsConfirmationProps> = ({ dialogContent, isDialogOpen }) => {
  return (
    <>
      {isDialogOpen && (
        <ModalWeb
          open={isDialogOpen}
          title={dialogContent?.title}
          description={dialogContent?.body}
          messageConfirmButton={dialogContent?.buttonTexts?.[0]}
          messageCancelButton={dialogContent?.buttonTexts?.[1]}
          onConfirmButton={dialogContent?.onPressConfirm}
          onCancelButton={dialogContent?.onPressDismiss}
          onClose={dialogContent?.onPressDismiss}
        />
      )}
    </>
  )
}
